/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-API
 * Date: 8/5/21
 * Copyright All Rights Reserved
 */
// @flow
export const RETURN_PERIOD_ID = 'returnPeriod';
export const PERFORMANCE_METRIC_ID = 'performanceMetric';
export const SCENARIO_ID = 'scenarioId';
export const CONFIDENCE_LEVEL_ID = 'confidenceLevel';
export const allSearchParams = [
  RETURN_PERIOD_ID,
  PERFORMANCE_METRIC_ID,
  SCENARIO_ID,
  CONFIDENCE_LEVEL_ID,
];

export type AllSearchParams = {|
  confidenceLevel: string | null,
  performanceMetric: string | null,
  scenarioId: string | null,
  returnPeriod: string | null,
|};



// WEBPACK FOOTER //
// ./js/constants/searchParams.js